import { Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { useClientParamBool } from "@/hooks/useClientParam";

const OfficerReportNarrative = ({ report = {}, startingPoint = "" }) => {
  // ASP: Globals/NarrativeMixedCase (default True)
  const narrativeMixedCase = useClientParamBool("Globals", "NarrativeMixedCase", true);
  return (
    <FieldSecurityProvider
      entity="OffenseDetails"
      startingPoint={startingPoint}
    >
      <Form
        layout="vertical"
        initialValues={{ narrative: report.narrative || "" }}
      >
        <StyledGridRow gutter={16} justify={'start'}>
          <StyledGridCol xs={24}>
            <SecureFormItem
              fieldName="narrative"
              formItemProps={{ name: "narrative", label: "Narrative" }}
            >
              <TextField rows="8" inputType="textarea" mixedCase={narrativeMixedCase} />
            </SecureFormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </FieldSecurityProvider>
  );
};

export default OfficerReportNarrative;
